import React from "react";
import ReactMarkdown from "react-markdown";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

import classNames from "classnames";

export const FAQ = ({ faq }) => {
  return (
    <Disclosure as="div" key={faq.question}>
      {({ open }) => (
        <>
          <dt className="w-full bg-white border border-gray-200 hover:shadow-md text-gray-400 rounded-lg">
            <Disclosure.Button className="text-left w-full items-start cursor-pointer">
              <div className="flex justify-between p-6">
                <span
                  className={classNames(
                    open ? "text-blue-500" : "text-gray-900",
                    "font-medium",
                  )}
                >
                  {faq.question}
                </span>
                <span className="ml-6 h-7 flex items-center">
                  <ChevronDownIcon
                    className={classNames(
                      open ? "-rotate-180" : "rotate-0",
                      "h-6 w-6 transform",
                    )}
                  />
                </span>
              </div>
            </Disclosure.Button>
            <Disclosure.Panel as="dd" className="px-6 pb-6">
              <div className="prose text-gray-500">
                <ReactMarkdown>{faq.answer}</ReactMarkdown>
              </div>
            </Disclosure.Panel>
          </dt>
        </>
      )}
    </Disclosure>
  );
};
